import img0 from "./images/i9-13900k-resize.png";
import img1 from "./images/Ryzen-7-7700X-resize.jpeg";
import img2 from "./images/MSI-RTX3060Ti-resize.png";
import img3 from "./images/Powercolor-Radeon-6600-resize.jpeg";
import img4 from "./images/Corsair-Vengeance-DDR4-8gb-resize.jpeg";
import img5 from "./images/RAM-Vengeance-ProRGB-16GB-resize.jpeg";
import img6 from "./images/ASUS ROG STRIX Z790-H-resize.jpg";
import img7 from "./images/MSI-MPG-Z490-resize.jpg";
import img8 from "./images/980pro-ssd-resize.jpeg";
import img9 from "./images/hdd-resize.png";
import img10 from "./images/Corsair-4000D-resize.jpeg";
import img11 from "./images/Thermaltake-Versa-H18-resize.jpeg";

export const images: { [key: string]: string } = {
    "./images/i9-13900k-resize.png": img0,
    "./images/Ryzen-7-7700X-resize.jpeg": img1,
    "./images/MSI-RTX3060Ti-resize.png": img2,
    "./images/Powercolor-Radeon-6600-resize.jpeg": img3,
    "./images/Corsair-Vengeance-DDR4-8gb-resize.jpeg": img4,
    "./images/RAM-Vengeance-ProRGB-16GB-resize.jpeg": img5,
    "./images/ASUS ROG STRIX Z790-H-resize.jpg": img6,
    "./images/MSI-MPG-Z490-resize.jpg": img7,
    "./images/980pro-ssd-resize.jpeg": img8,
    "./images/hdd-resize.png": img9,
    "./images/Corsair-4000D-resize.jpeg": img10,
    "./images/Thermaltake-Versa-H18-resize.jpeg": img11
};
